// Funnel Components
import AlgoliaSearchBox from '../components/AlgoliaSearchBox';
import UpdatePaymentForm from '../components/forms/UpdatePaymentForm';
import Navigation from '../components/Navigation';
import NavigationDrawer from '../components/NavigationDrawer';
import ProPage from '../pages/ProPage';
import { BranchAppText } from '../application/javascripts/react_components/branch/branch_app_text';
import { GiftFlow } from '../components/GiftFlow/GiftFlow/GiftFlow';
import { LanguageMenuDropdown } from '../application/javascripts/react_components/language_menu_dropdown';
import { MobileRoadblock } from '../application/javascripts/react_components/branch/mobile_roadblock';
import LoginForm from '../components/forms/LoginForm';
import ProfileSlidingTabs from '../components/profile/ProfileSlidingTabs';
import { QuoteRotator } from '../application/javascripts/react_components/quote_rotator';
import RedemptionPage from '../components/RedemptionPage';
import { RoadblockedAnchor } from '../application/javascripts/react_components/branch/roadblocked_anchor';
import SignUpForm from '../components/forms/SignUpForm';

const ReactRailsUJS = require('react_ujs');

const context = {
  AlgoliaSearchBox,
  BranchAppText,
  UpdatePaymentForm,
  GiftFlow,
  LanguageMenuDropdown,
  LoginForm,
  MobileRoadblock,
  Navigation,
  NavigationDrawer,
  ProPage,
  QuoteRotator,
  RedemptionPage,
  RoadblockedAnchor,
  ProfileSlidingTabs,
  SignUpForm
};
ReactRailsUJS.getConstructor = className => {
  return context[className];
};
